import { lazy } from 'react'
import { retry } from '../../helpers/chunkHelpers'

const modules = {
  AccountDetails: lazy(() => retry(() => import('./accountDetails'))),
  AuctionDetails: lazy(() => retry(() => import('./auctionDetails'))),
  AuctionsArchived: lazy(() => retry(() => import('./auctionsArchived'))),
  AuctionList: lazy(() => retry(() => import('./auctionList'))),
  AuctionRegistration: lazy(() => retry(() => import('./auctionRegistration'))),
  Login: lazy(() => retry(() => import('./login'))),
  TimedDetails: lazy(() => retry(() => import('./timedDetails'))),
  TimedList: lazy(() => retry(() => import('./timedList'))),
  TimedSingle: lazy(() => retry(() => import('./timedSingle')))
}

export default modules
